import state from './medium.state'
import mutations from './medium.mutations'
import actions from './medium.actions'
import getters from './medium.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



//////////////////
// WEBPACK FOOTER
// ./state/medium/medium.module.js
// module id = null
// module chunks = 